module.exports = __webpack_public_path__ + "img/hongen-logo.88f53089.png";